import { Table } from "react-bootstrap";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const StatusSummaryTable = ({ userActivityLoader, userActivity = [] }) => {
  return (
    <>
      {userActivityLoader ? (
        <div
          className="hstack justify-content-center"
          style={{ height: "calc(100vh - 500px)" }}
        >
          <PageLoader />
        </div>
      ) : (
        <Table className="m-0 custom-table" hover striped>
          <thead className="position-sticky top-0 z-1">
            <tr>
              <th>Status</th>
              <th>Queries</th>
              <th>%</th>
              <th>Avg Aging</th>
              <th>Oldest</th>
              <th>SLA Breach</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Open</td>
              <td>112</td>
              <td>13.6%</td>
              <td>19.8 d</td>
              <td>166 d</td>
              <td>56</td>
            </tr>
          </tbody>
        </Table>
      )}
    </>
  );
};

export default StatusSummaryTable;
